import { render, staticRenderFns } from "./PointChange.vue?vue&type=template&id=782224a7&scoped=true"
import script from "./PointChange.vue?vue&type=script&lang=js"
export * from "./PointChange.vue?vue&type=script&lang=js"
import style0 from "./PointChange.vue?vue&type=style&index=0&id=782224a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782224a7",
  null
  
)

export default component.exports